import React from 'react';
import {
  Redirect, Route, useLocation, withRouter,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';

const SecureRoute = (props) => {
  const {
    isLoading,
    isAuthenticated,
    component: RenderComponent,
    countryCode,
    ...rest
  } = props;

  const { pathname, search } = useLocation();

  return (
    isLoading
      ? (
        <div className="loader animated fadeIn pt-3 text-center">
          <div className="sk-spinner sk-spinner-pulse" />
        </div>
      )
      : !isAuthenticated
        ? <Redirect to={`/login?redirect=${pathname}${search}`} />
        :     <Route {...rest} render={(props) => <RenderComponent {...rest} {...props} />} /> // eslint-disable-line
  );
};

const mapStateToProps = (state) => {
  const {
    isLoading, isAuthenticated, token, user,
  } = state.auth;

  return {
    isLoading,
    isAuthenticated,
    token: Cookies.get('auth-token') || token,
    isAccredited: user && user.isAccredited,
    countryCode: user && user.countryCode,
  };
};

SecureRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  isLoading: PropTypes.bool,
  component: PropTypes.func,
  token: PropTypes.string,
  countryCode: PropTypes.string,
};

SecureRoute.defaultProps = {
  isAuthenticated: false,
  isLoading: false,
  component: null,
  token: null,
  countryCode: null,
};

export default connect(
  mapStateToProps,
  null,
)(withRouter(SecureRoute));
